import * as React from 'react';
import SetOrResetPassword from './SetOrResetPassword';

class SetPassword extends React.Component <{}, {}> {
    public render() {
        return (
            <SetOrResetPassword title="Set Password"/>
        );
    }
}

export default SetPassword;



// WEBPACK FOOTER //
// ./src/Components/Auth/SetPassword.tsx